module.exports = __webpack_public_path__ + "media/impact2.a5e9d841.mp3";